module.exports = __webpack_public_path__ + "static/task_posted-3e1e4466a8196a44876f52e7e28f33a3.png";